import React from "react";
import { Routes, Route } from "react-router-dom";
import TrainerDashboard from '../components/TrainerDashboard/TrainerDashboard';
import TrainerProfile from '../components/TrainerDashboard/TrainerProfile';

const TrainerRoutes = () => {
  return (
    <Routes>
      <Route path="/trainer-dashboard" element={<TrainerDashboard />} />
      <Route path="/trainer-profile" element={<TrainerProfile />} />
    </Routes>
  );
};

export default TrainerRoutes;
